import { combineReducers, configureStore, Store } from '@reduxjs/toolkit';
import createSagaMiddleware, { Task } from 'redux-saga';
import { useDispatch } from 'react-redux';
import rootSaga from './saga';
import analyticsReducer from './reducers/analytics';
import authReducer from './reducers/auth';
import billingReducer from './reducers/billing';
import companyReducer from './reducers/company';
import companyBillingReducer from './reducers/companyBilling';
import companyMetricsReducer from './reducers/companyMetrics';
import companiesSummaryReducer from './reducers/companiesSummary';
import headsetsReducer from './reducers/headsets';
import packagesReducer from './reducers/packages';
import problemHeadsetsReducer from './reducers/problemHeadsets';
import reportsHeadsetsReducer from './reducers/reportHeadsets';
import offlineHeadsetsReducer from './reducers/offlineHeadsets';
import deviceEventsReducer from './reducers/deviceEvents';
import batteryReducer from './reducers/battery';
import popUpNotificationsReducer from './reducers/popUpNotifications';

const reducer = combineReducers({
  analytics: analyticsReducer,
  auth: authReducer,
  billing: billingReducer,
  companies: companyReducer,
  companyBilling: companyBillingReducer,
  companyMetrics: companyMetricsReducer,
  companiesSummary: companiesSummaryReducer,
  headsets: headsetsReducer,
  packages: packagesReducer,
  problemHeadsets: problemHeadsetsReducer,
  reportsHeadsets: reportsHeadsetsReducer,
  offlineHeadsets: offlineHeadsetsReducer,
  deviceEvents: deviceEventsReducer,
  battery: batteryReducer,
  popUpNotifications: popUpNotificationsReducer,
});

export interface SagaStore extends Store {
  sagaTask: Task;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(sagaMiddleware),
    devTools: true,
  });

  (store as SagaStore).sagaTask = sagaMiddleware.run(rootSaga);
  return store;
};

export const store = createStore();
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export type RootState = ReturnType<typeof reducer>;

export default createStore;
